import DOMPurify from 'dompurify'

export const sanitizeHtml = (raw: string): string =>
  DOMPurify.sanitize(raw, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'br', 'span', 'p'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
  })
